import { render, staticRenderFns } from "./report-view.vue?vue&type=template&id=9d6c8f06&scoped=true&"
import script from "./report-view.vue?vue&type=script&lang=js&"
export * from "./report-view.vue?vue&type=script&lang=js&"
import style0 from "./report-view.vue?vue&type=style&index=0&id=9d6c8f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6c8f06",
  null
  
)

export default component.exports